import axios from 'axios';
import APIS from 'src/utils/apiUrl';
import { getAuthToken } from 'src/utils/auth/getAuthToken';
import { ThunkAction } from 'redux-thunk';
import { AppState } from 'src/redux/types';
import { AnyAction } from 'redux';
import { logTagsActions } from '../actions';
import { LogTag } from '../../../models/logTags';

export const fetchLogTagsByOrgId =
  (orgId: string): ThunkAction<void, AppState, undefined, AnyAction> =>
  async dispatch => {
    dispatch(logTagsActions.tryFetchLogTagsStart());
    const token = await getAuthToken();
    if (!token) throw new Error('Tried to fetch auth token without an auth token!');

    const accessToken = token.access.token;
    const opts = {
      headers: { Authorization: `Bearer ${accessToken}` },
      params: { query: { orgId: orgId } },
    };

    try {
      const { data: logTags }: { data: LogTag[] } = await axios.get(`${APIS.SENTINEL_API}/api/log-tags/list`, opts);
      dispatch(logTagsActions.tryFetchLogTagsSuccess(logTags));
    } catch (error) {
      console.log('error', error);
      dispatch(logTagsActions.tryFetchLogTagsFailure());
    }
  };
